import React from 'react';
import { Building2, Home, Store } from 'lucide-react';
import { useSimulateur } from '../SimulateurContext';

export const Step2PropertyType = () => {
  const { formData, updateFormData, goToNextStep } = useSimulateur();

  const handleSelect = (type) => {
    updateFormData('propertyType', type);
    goToNextStep();
  };

  const options = [
    {
      id: 'appartement',
      icon: Building2,
      title: 'Appartement',
      description: 'Studio, T2, T3, T4, T5+',
    },
    {
      id: 'maison',
      icon: Home,
      title: 'Maison',
      description: 'Maison individuelle ou mitoyenne',
    },
    {
      id: 'local',
      icon: Store,
      title: 'Local commercial',
      description: 'Bureau, commerce, entrepôt',
    },
  ];

  return (
    <div className="space-y-8">
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900">
          Quel type de bien ?
        </h2>
        <p className="text-stone-600">
          Le type de bien détermine les diagnostics requis et leur tarification
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {options.map((option) => {
          const Icon = option.icon;
          const isSelected = formData.propertyType === option.id;

          return (
            <button
              key={option.id}
              onClick={() => handleSelect(option.id)}
              data-testid={`property-type-${option.id}`}
              className={`
                relative p-6 rounded-2xl border-2 transition-all duration-300
                hover:shadow-lg hover:-translate-y-1 group
                ${isSelected 
                  ? 'border-emerald-500 bg-emerald-50 shadow-md' 
                  : 'border-stone-200 bg-white hover:border-emerald-300'
                }
              `}
            >
              {isSelected && (
                <div className="absolute top-3 right-3 w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              
              <div className="flex flex-col items-center text-center space-y-3">
                <div className={`
                  w-14 h-14 rounded-xl flex items-center justify-center transition-colors duration-300
                  ${isSelected 
                    ? 'bg-emerald-500 text-white' 
                    : 'bg-stone-100 text-stone-600 group-hover:bg-emerald-100 group-hover:text-emerald-600'
                  }
                `}>
                  <Icon className="w-7 h-7" />
                </div>
                
                <div>
                  <h3 className={`
                    text-lg font-semibold mb-1 transition-colors duration-300
                    ${isSelected ? 'text-emerald-700' : 'text-stone-900'}
                  `}>
                    {option.title}
                  </h3>
                  <p className="text-stone-500 text-xs">
                    {option.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
